import { CARD_DESCRIPTION_UNSAVED_LOCALSTORAGE, ICardDescriptionUnsavedLocalStorage } from '../types';

export const setCardDescriptionUnsavedLocalStorage = (
    cardDescriptionLocalStorage: ICardDescriptionUnsavedLocalStorage
) => {
    localStorage.setItem(CARD_DESCRIPTION_UNSAVED_LOCALSTORAGE, JSON.stringify(cardDescriptionLocalStorage))
};
